// import React, { useContext, useState, useEffect, useCallback } from "react";
// import { FilterContext } from "../../context/Filter";
// import { axInstBasic } from "../../components/Service/Service";
// import { useQuery } from "@tanstack/react-query";
// import FleetEdgeDropDownTable from "../../components/Table/FleetEdgeDropDownTable";


// // Fetch dropdown options
// const vehicleDetailReportOption = async (parArn, childArn, selectedReg) => {
//   if (!parArn && !childArn) return [];
//   if (!selectedReg) return [];
//   const values = {
//     ...(childArn ? { childArn } : { parArn }),
//   };

//   const payload = { ...values, search_type: selectedReg };
//   const res = await axInstBasic.post(
//     `${process.env.REACT_APP_API_URL}fleet-detail-report-option`,
//     payload
//   );
//   return res.data?.options || [];
// };

// // Fetch table data
// const vehicleDetailsReports = async (
//   parArn,
//   childArn,
//   selectedReg,
//   selectedValue
// ) => {
//   if (!parArn && !childArn) return [];
//   if (!selectedReg || !selectedValue) return [];

//   const values = {
//     ...(childArn ? { childArn } : { parArn }),
//   };

//   const payload = {
//     ...values,
//     search_type: selectedReg,
//     dropDownValue: selectedValue,
//   };

//   const res = await axInstBasic.post(
//     `${process.env.REACT_APP_API_URL}fleet-details-data`,
//     payload
//   );

//   const hits = res.data?.result || [];

//   // Flatten _source and merge doc_count
//   return hits;
// };

// const Fleettable = () => {
//   const [selectedReg, setSelectedReg] = useState("");
//   const [selectedValue, setSelectedValue] = useState("");
//   const [isValueDropdownOpen, setIsValueDropdownOpen] = useState(false);
//   const [valueSearch, setValueSearch] = useState("");

//   const { open } = useContext(FilterContext);

//   const { arn: contextParArn, childArn: contextChildArn } =
//     useContext(FilterContext);
//   const parArn = contextParArn || "";
//   const childArn = contextChildArn || null;
//   const isContextReady = !!parArn || !!childArn;


//   useEffect(() => {
//     setSelectedValue(""); // reset second dropdown on first dropdown change
//   }, [selectedReg]);

//   const {
//     data: vehicleDetailReportOptionData = [],
//     isLoading: isOptionsLoading,
//     isError: isOptionsError,
//     error: optionError,
//   } = useQuery({
//     queryKey: ["vehicleDetailReport", parArn, childArn, selectedReg],
//     queryFn: () => vehicleDetailReportOption(parArn, childArn, selectedReg),
//     enabled: isContextReady && !!selectedReg,
//   });

//   const {
//     data: vehicleDetailsReportsData = [],
//     isLoading: isTableLoading,
//     isError: isTableError,
//     error: tableError,
//   } = useQuery({
//     queryKey: ["vehicleDetails", parArn, childArn, selectedReg, selectedValue],
//     queryFn: () =>
//       vehicleDetailsReports(parArn, childArn, selectedReg, selectedValue),
//     enabled: isContextReady && !!selectedReg && !!selectedValue,
//   });

//   const handleFirstDropdownChange = useCallback((e) => {
//     setSelectedReg(e.target.value);
//   }, []);

//   const handleSecondDropdownChange = useCallback((e) => {
//     setSelectedValue(e.target.value);
//   }, []);

//   const filteredVehicleOptions = useCallback(() => {
//     if (!valueSearch) return vehicleDetailReportOptionData;

//     return vehicleDetailReportOptionData.filter((item) =>
//       String(item).toLowerCase().includes(valueSearch.toLowerCase())
//     );
//   }, [vehicleDetailReportOptionData, valueSearch]);
//   return (
//     <div className="w-96 md:w-full">
//       <div
//         className={`bg-[#2374BF]  ${open ? "w-[990px]" : "w-[1180px]"
//           }  mt-2 text-lg text-white text-center py-1`}
//       >
//         Performance Data
//       </div>

//       <div className="block md:flex gap-20 px-4 py-3 items-center justify-center">
//         {/* First Dropdown */}
//         <div className="flex flex-col">
//           <label htmlFor="filterBy" className="text-sm font-medium mb-1">
//             Filter By
//           </label>
//           <select
//             id="filterBy"
//             value={selectedReg}
//             onChange={handleFirstDropdownChange}
//             className="border border-gray-300 w-64 font-medium rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
//           >
//             <option value="">Select Filter</option>
//             <option value="chassis_number">Chassis Number</option>
//             <option value="product_line">Product Line</option>
//             <option value="VEHICLE_REGISTRATION_NUMBER">Vehicle Registration Number</option>
//             <option value="PPL">PPL</option>
//             <option value="PL">PL</option>
//             <option value="LOB">LOB</option>
//           </select>
//         </div>

//         {/* Second Dropdown */}
//         <div className="relative w-64">
//           <label className="text-sm font-medium mb-1 block">
//             Select Value
//           </label>

//           {/* Search Input */}
//           <input
//             type="text"
//             value={valueSearch}
//             placeholder={
//               isOptionsLoading
//                 ? "Loading..."
//                 : !selectedReg
//                   ? "Select Filter First"
//                   : "Search value..."
//             }
//             disabled={
//               !selectedReg ||
//               isOptionsLoading ||
//               isOptionsError ||
//               vehicleDetailReportOptionData.length === 0
//             }
//             onChange={(e) => {
//               setValueSearch(e.target.value);
//               setIsValueDropdownOpen(true);
//             }}
//             onFocus={() => setIsValueDropdownOpen(true)}
//             className="border border-gray-300 w-full font-medium rounded px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//           />

//           {/* Dropdown list */}
//           {isValueDropdownOpen &&
//             selectedReg &&
//             !isOptionsLoading &&
//             !isOptionsError && (
//               <ul className="absolute z-20 w-full bg-white border border-gray-300 rounded mt-1 max-h-48 overflow-y-auto shadow">
//                 {filteredVehicleOptions().length === 0 ? (
//                   <li className="px-3 py-2 text-sm text-gray-500">
//                     No results found
//                   </li>
//                 ) : (
//                   filteredVehicleOptions().map((item, index) => (
//                     <li
//                       key={`${item}-${index}`}
//                       className="px-3 py-2 cursor-pointer hover:bg-blue-100 text-sm"
//                       onClick={() => {
//                         setSelectedValue(item);
//                         setValueSearch(item);
//                         setIsValueDropdownOpen(false);

//                         // 🔥 reuse existing handler
//                         handleSecondDropdownChange({
//                           target: { value: item },
//                         });
//                       }}
//                     >
//                       {item}
//                     </li>
//                   ))
//                 )}
//               </ul>
//             )}
//         </div>
//       </div>


//       {/* Table section */}
//       {isTableLoading && (
//         <p className="text-center text-blue-600 mt-4">Loading report data...</p>
//       )}
//       {isTableError && (
//         <p className="text-center text-red-600 mt-4">
//           Failed to load report data: {tableError?.message || "Unknown error"}
//         </p>
//       )}
//       <div className="mt-4">
//         <FleetEdgeDropDownTable data={vehicleDetailsReportsData} />
//       </div>
//     </div>
//   );
// };

// export default Fleettable;
import React, { useContext, useState, useEffect, useCallback } from "react";
import { FilterContext } from "../../context/Filter";
import { axInstBasic } from "../../components/Service/Service";
import { useQuery } from "@tanstack/react-query";
import FleetEdgeDropDownTable from "../../components/Table/FleetEdgeDropDownTable";

/* ================= API CALLS ================= */

// Fetch dropdown options
const vehicleDetailReportOption = async (parArn, childArn, selectedReg) => {
  if (!parArn && !childArn) return [];
  if (!selectedReg) return [];

  const payload = {
    ...(childArn ? { childArn } : { parArn }),
    search_type: selectedReg,
  };

  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}fleet-detail-report-option`,
    payload
  );

  return res.data?.options || [];
};

// Fetch table data
const vehicleDetailsReports = async (
  parArn,
  childArn,
  selectedReg,
  selectedValue
) => {
  if (!parArn && !childArn) return [];
  if (!selectedReg || !selectedValue) return [];

  const payload = {
    ...(childArn ? { childArn } : { parArn }),
    search_type: selectedReg,
    dropDownValue: selectedValue,
  };

  const res = await axInstBasic.post(
    `${process.env.REACT_APP_API_URL}fleet-details-data`,
    payload
  );

  return res.data?.result || [];
};

/* ================= COMPONENT ================= */

const Fleettable = () => {
  const { open, arn: contextParArn, childArn: contextChildArn } =
    useContext(FilterContext);

  const parArn = contextParArn || "";
  const childArn = contextChildArn || null;
  const isContextReady = !!parArn || !!childArn;

  const [selectedReg, setSelectedReg] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [valueSearch, setValueSearch] = useState("");
  const [isValueDropdownOpen, setIsValueDropdownOpen] = useState(false);

  /* ================= EFFECTS ================= */

  // Reset second dropdown when first dropdown changes
  useEffect(() => {
    setSelectedValue("");
    setValueSearch("");
    setIsValueDropdownOpen(false);
  }, [selectedReg]);

  /* ================= QUERIES ================= */

  const {
    data: vehicleDetailReportOptionData = [],
    isLoading: isOptionsLoading,
    isError: isOptionsError,
  } = useQuery({
    queryKey: ["vehicleDetailReport", parArn, childArn, selectedReg],
    queryFn: () => vehicleDetailReportOption(parArn, childArn, selectedReg),
    enabled: isContextReady && !!selectedReg,
  });

  const {
    data: vehicleDetailsReportsData = [],
    isLoading: isTableLoading,
    isError: isTableError,
    error: tableError,
  } = useQuery({
    queryKey: ["vehicleDetails", parArn, childArn, selectedReg, selectedValue],
    queryFn: () =>
      vehicleDetailsReports(parArn, childArn, selectedReg, selectedValue),
    enabled: isContextReady && !!selectedReg && !!selectedValue,
  });

  /* ================= HANDLERS ================= */

  const handleFirstDropdownChange = useCallback((e) => {
    setSelectedReg(e.target.value);
  }, []);

  const handleSecondDropdownChange = useCallback((value) => {
    setSelectedValue(value);
  }, []);

  /* ================= FILTERED OPTIONS ================= */

  const filteredVehicleOptions = valueSearch
    ? vehicleDetailReportOptionData.filter((item) =>
      String(item).toLowerCase().includes(valueSearch.toLowerCase())
    )
    : vehicleDetailReportOptionData;

  /* ================= UI ================= */

  return (
    <div className="w-96 md:w-full">
      <div
        className={`bg-[#2374BF] ${open ? "w-[990px]" : "w-[1180px]"
          } mt-2 text-lg text-white text-center py-1`}
      >
        Performance Data
      </div>

      <div className="block md:flex gap-20 px-4 py-3 items-center justify-center">
        {/* First Dropdown */}
        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1">Filter By</label>
          <select
            value={selectedReg}
            onChange={handleFirstDropdownChange}
            className="border border-gray-300 w-64 font-medium rounded px-3 py-1"
          >
            <option value="">Select Filter</option>
            <option value="chassis_number">Chassis Number</option>
            <option value="product_line">Product Line</option>
            <option value="VEHICLE_REGISTRATION_NUMBER">
              Vehicle Registration Number
            </option>
            <option value="PPL">PPL</option>
            <option value="PL">PL</option>
            <option value="LOB">LOB</option>
          </select>
        </div>

        {/* Second Dropdown (SEARCHABLE) */}
        <div className="relative w-64">
          <label className="text-sm font-medium mb-1 block">Select Value</label>

          <input
            type="text"
            value={valueSearch}
            placeholder={
              !selectedReg
                ? "Select Filter First"
                : isOptionsLoading
                  ? "Loading..."
                  : "Search value..."
            }
            disabled={!selectedReg || isOptionsLoading || isOptionsError}
            onChange={(e) => {
              setValueSearch(e.target.value);
              setIsValueDropdownOpen(true);
            }}
            onFocus={() => setIsValueDropdownOpen(true)}
            className="border border-gray-300 w-full font-medium rounded px-3 py-1 disabled:bg-gray-100"
          />

          {isValueDropdownOpen && filteredVehicleOptions.length > 0 && (
            <ul className="absolute z-20 w-full bg-white border border-gray-300 rounded mt-1 max-h-48 overflow-y-auto shadow">
              {filteredVehicleOptions.map((item, index) => (
                <li
                  key={`${item}-${index}`}
                  className="px-3 py-2 cursor-pointer hover:bg-blue-100 text-sm"
                  onClick={() => {
                    handleSecondDropdownChange(item);
                    setValueSearch(item);
                    setIsValueDropdownOpen(false);
                  }}
                >
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Table */}
      {isTableLoading && (
        <p className="text-center text-blue-600 mt-4">Loading report data...</p>
      )}

      {isTableError && (
        <p className="text-center text-red-600 mt-4">
          Failed to load report data: {tableError?.message || "Unknown error"}
        </p>
      )}

      <div className="mt-4">
        <FleetEdgeDropDownTable data={vehicleDetailsReportsData} />
      </div>
    </div>
  );
};

export default Fleettable;

